import React from 'react';
import { Filter, X } from 'lucide-react';

export default function CalendarFilters({ filters, onFilterChange, services }) {
  const statuses = [
    { value: '', label: 'All Statuses' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'no_show', label: 'No Show' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onFilterChange({ status: '', serviceId: '', assignedTo: '' });
  };

  const hasActiveFilters = filters?.status || filters?.serviceId || filters?.assignedTo;

  return (
    <div className="bg-white border-b border-gray-200 px-6 py-3">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 text-gray-700">
          <Filter className="w-4 h-4" />
          <span className="text-sm font-medium">Filters:</span>
        </div>

        <select
          value={filters?.status}
          onChange={(e) => handleFilterChange('status', e?.target?.value)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {statuses?.map((status) => (
            <option key={status?.value} value={status?.value}>
              {status?.label}
            </option>
          ))}
        </select>

        <select
          value={filters?.serviceId}
          onChange={(e) => handleFilterChange('serviceId', e?.target?.value)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">All Services</option>
          {services?.map((service) => (
            <option key={service?.id} value={service?.id}>
              {service?.name}
            </option>
          ))}
        </select>

        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            <X className="w-4 h-4" />
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
}